import { KnowledgeDocument } from '@/types/knowledge';
import { DocumentCard } from './DocumentCard';

interface RelatedDocumentsProps {
  documents: KnowledgeDocument[];
  onDocumentClick: (id: string) => void;
}

export function RelatedDocuments({ documents, onDocumentClick }: RelatedDocumentsProps) {
  if (documents.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-8">
        Nenhum documento relacionado encontrado
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {documents.map((doc) => (
        <DocumentCard
          key={doc.id}
          document={doc}
          onClick={() => onDocumentClick(doc.id)}
        />
      ))}
    </div>
  );
}
